import React from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import toast from 'react-hot-toast'
import CardLayoutLink from '../../components/layout/CardLayoutLink'
import Flex from '../../components/Flex'
import NewPasswordForm from '../../components/form/forms/NewPasswordForm'
import { Navigate, useSearchParams } from 'react-router-dom'

const NewPasswordScene = ({ ...rest }) => {
  const dispatch = useDispatch()
  const [search] = useSearchParams()
  const username = search.get('username')
  const code = search.get('code')
  const event = search.get('event')

  const error = useSelector((state) => state.auth.error)
  const [loading, setLoading] = React.useState(false)
  const [navigate, setNavigate] = React.useState(false)

  React.useEffect(() => {
    if (error) {
      toast.error(error.message)
      dispatch.auth.CLEAR_ERROR()
    }
  }, [error])

  const handleFormSubmit = async (values) => {
    setLoading(true)
    setNavigate(
      await dispatch.auth.requestForgotPasswordSubmit({
        username,
        code,
        password: values.password,
        event,
      })
    )
    setLoading(false)
  }

  return (
    <CardLayoutLink loading={loading} error={error} {...rest} cancel="/">
      <Flex vertical centerY>
        <Flex vertical padding="1rem" css={styles.content}>
          <NewPasswordForm loading={loading} submit={handleFormSubmit} />
        </Flex>
      </Flex>
      {navigate && <Navigate to="/auth/login" />}
    </CardLayoutLink>
  )
}

const styles = {
  content: {
    maxWidth: 630,
  },
  info: {
    marginBottom: '16px',
    marginTop: '32px',
  },
}

export default NewPasswordScene
